export const Orientation = Object.freeze({
  LANDSCAPE: "landscape",
  PORTRAIT: "portrait"
});
